import '../../css/mk-brand.css';
import {useEffect} from "react";

function Panel() {
  useEffect(() => {}, );
  return (
      <div id="features-panel" className="m-2">
        <div className="container bg-zinc-800 pt-4 px-4 md:px-40 pb-4 rounded-lg max-w-4xl">
          <div className="">
            <div className="max-w-xl mx-auto mb-10">
              <h2 className="flex">
                <h2 className="mb-2 text-4xl sm:text-6xl font-extrabold leading-none">
                  m
                </h2>
                <h2 className="mb-2 text-4xl sm:text-6xl font-extrabold leading-none">
                  K
                </h2>
                <h2 className="mb-2 text-4xl sm:text-6xl font-extrabold leading-none text-brand">
                  Battle
                </h2>
              </h2>
              <p className="mb-6 text-white md:text-2xl">
                mKBattle is a blockchain PvP cooking battle game inspired by Iron Chef. Chefs will leverage their NFT assets and put them on the line against other players for culinary glory and delicious rewards. Want to know more? Read our white paper.
              </p>
            </div>
            <div className="px-8 md:p-10 lg:p-4">
              <div className="cursor-pointer">
                <a href="https://metakitchen.gitbook.io/metakitchen-wp/wb1pN4vYLKsa8w4IX5qL/"
                   className="text-black font-bold bg-gray-500 py-2 px-10 rounded-full text-lg hover:bg-brand transition ease-in-out delay-150">White Paper</a>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default Panel;